import styled from 'styled-components'

export const ErrorTitle = styled.div`
  width: 100%;
  padding: 16px;
  text-align: center;
`
